import React, { useState, useEffect } from 'react';

import ManagementAgencyEntity from '../../Components/ManagementAgencyEntity'
import ModalWarn from '../../Components/Modal/Warn/index'
import { normalizeKeys } from '../../utils';

export default function AgencyEntityManagement(props) {
    const [ loading, setLoading] = useState(false);
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [ pageOptions, setPageOptions ] = useState([
        /*
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        */
    ]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });

    const [ modalError, setModalError ] = useState(false);

    const [ orgaoEntidadeList, setOrgaoEntidadeList ] = useState([ ]);

    const [ successMsg, setSuccessMsg ] = useState();

    const [ totalFilter, setTotalFilter ] = useState("0");

    const [selectedAgency, setSelectedAgency] = useState({});

    const [ municipioOptions, setMunicipioOptions ] = useState([])

    const [ erroMsg, setErroMsg ] = useState('');

    const [isModalConfirmUnblockVisible, setModalConfirmUnblockVisible] = useState(false);
    
    const [isModalConfirmAgencyEntityBlockVisible, setModalConfirmAgencyEntityBlockVisible] = useState(false);

    const [loadModalconfirmUnblock, setLoadModalconfirmUnblock] = useState(false);

    const [loadModalconfirmAgencyEntityBlock, setLoadModalconfirmAgencyEntityBlock] = useState(false);

    const [loadingMunicipios, setLoadingMunicipios] = useState(false);

    const [cleanFiltro, setCleanFiltro] = useState(false);

    const [newStatus, setNewStatus] = useState();

    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)


    useEffect(() => {
        
    }, [props.location.state]);

    const onSubmitSearch = async (data) => {
        const user = JSON.parse(localStorage.getItem('user'))
        setLoading(true);
        setOrgaoEntidadeList([]);
        setErroMsg('');
        setSuccessMsg(undefined);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': user ? user.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user.cpf_atendente,
                nome_orgao: data.nome_orgao,
                nome_rede_atendimento: data.nome_rede_atendimento, 
                status_orgao: data.status_orgao,
                abrangencia: data.abrangencia,
                uf: data.uf,
                codigo_municipio: data.codigo_municipio,
                pagina_atual: "1",
                qtd_registros: rangePages.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaOrgaos`, requestOptions).then(function(response) {
            setLoading(false);
            if (response.ok) {
                response.json().then(function(resp) {
                    // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                    const maxPageOption = Math.ceil(Number(resp.total) / Number(rangePages.value))
                    let list = []
                    let obj = {}
                    for(var i = 1; i <= maxPageOption; i++) {
                        obj = {
                            value: String(i),
                            label: String(i)
                        }

                        list.push(obj);
                    }

                    setPageOptions(list);
                    setPage({label: "1", value: "1"});
                    setOrgaoEntidadeList(resp.orgaos);
                    setTotalFilter(resp.total);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message);
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                //setLoading(false);
                setModalError(true);
            }
        }).catch(function(err) {
            setLoading(false);
            console.error('Failed retrieving information', err);
        });
    };

    const onChangePaginationConfig = async (data, ranPag, pag, isRanPag) => {
        const user = JSON.parse(localStorage.getItem('user'))
        setErroMsg('');
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user.cpf_atendente,
                nome_orgao: data.nome_orgao,
                nome_rede_atendimento: data.nome_rede_atendimento, 
                status_orgao: data.status_orgao,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaOrgaos`, requestOptions).then(function(response) {
            setLoading(false);
            if (response.ok) {
                response.json().then(function(data) {
                    // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!

                    const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                    let list = []
                    let obj = {}
                    for(var i = 1; i <= maxPageOption; i++) {
                        obj = {
                            value: String(i),
                            label: String(i)
                        }

                        list.push(obj);
                    }

                    setPageOptions(list);
                    if(isRanPag){
                        setPage({label: "1", value: "1"});
                    }
                    setOrgaoEntidadeList(data.orgaos);
                    setTotalFilter(data.total);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message);
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                //setLoading(false);
                setModalError(true);
            }
        }).catch(function(err) {
            setLoading(false);
            console.error('Failed retrieving information', err);
        });
    };

    const onSubmitUnblock = async (data) => {
        const normalizedData = normalizeKeys(data);
        const user = JSON.parse(localStorage.getItem('user'))
        setLoading(true);
        setLoadModalconfirmUnblock(true)
        setOrgaoEntidadeList([]);
        setErroMsg('');
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': user ? user.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user.cpf_atendente,
                codigo_orgao: normalizedData.codigo_orgao
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/desbloqueiaOrgao`, requestOptions).then(function(response) {
            setLoading(false);
            setModalConfirmUnblockVisible(false)
            setLoadModalconfirmUnblock(false)
            if (response.ok) {
                response.json().then(function(resp) {
                    setSelectedAgency({});
                    setSuccessMsg(resp.message)
                    setNewStatus(resp.newStatus)
                    setCleanFiltro(true);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message);
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                //setLoading(false);
                setModalError(true);
            }
        }).catch(function(err) {
            setLoadModalconfirmUnblock(false)
            setModalConfirmUnblockVisible(false)
            setLoading(false);
        });
    };

    const onSubmitBloqueiaOrgaoEntidade = async (data) => {
        const normalizedData = normalizeKeys(data);
        const user = JSON.parse(localStorage.getItem('user'))
        setLoading(true);
        setLoadModalconfirmAgencyEntityBlock(true)
        setOrgaoEntidadeList([]);
        setErroMsg('');
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': user ? user.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user.cpf_atendente,
                codigo_orgao: normalizedData.codigo_orgao,
                motivo_bloqueio: normalizedData.motivo_bloqueio
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/bloqueiaOrgao`, requestOptions).then(function(response) {
            setLoadModalconfirmAgencyEntityBlock(false)
            setLoading(false);
            setModalConfirmAgencyEntityBlockVisible(false)
            if (response.ok) {
                response.json().then(function(resp) {
                    setSelectedAgency({});
                    setSuccessMsg(resp.message)
                    setNewStatus(resp.newStatus)
                    setCleanFiltro(true);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message);
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoading(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setModalError(true);
            }
        }).catch(function(err) {
            setModalConfirmAgencyEntityBlockVisible(false)
            setLoadModalconfirmAgencyEntityBlock(false)
            setLoading(false);
        });
    };

    async function listaMunicipios(uf) {
        setLoadingMunicipios(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                uf: uf
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaMunicipios`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    var municipios = [{value: 'TODOS', label: 'Todos'}];
                    var obj = {};

                    data.forEach((h) => {
                        obj = {
                            value: h.CODIGO_MUNICIPIO,
                            label: h.NOME_MUNICIPIO
                        };

                        municipios.push(obj);
                    });

                    setMunicipioOptions(municipios);
                });
            }
            setLoadingMunicipios(false);
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
            setLoadingMunicipios(false);
        });
    }
    
    return(
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ManagementAgencyEntity
                pageTitle='Gestão de rede de atendimento'
                buttonRegistrationTitle='+ Cadastrar rede de atendimento'
                buttonRegistrationRoute='/adicionarOrgao'
                fieldNamePlaceholder='Digite o nome do órgão/entidade responsável'
                fieldNamePlaceholder2='Digite o nome da rede de atendimento'
                tableResultListTitle='Lista das redes de atendimento cadastradas'
                buttonDetailRoute='/detalharOrgao'
                buttonEditRoute='/editarOrgao' 
                buttonNextLoading={loading}
                onSubmitSearch={onSubmitSearch}
                onChangePaginationConfig={onChangePaginationConfig}
                onSubmitUnblock={onSubmitUnblock}
                onSubmitAgencyEntityBlock={onSubmitBloqueiaOrgaoEntidade}
                listMunicipality={listaMunicipios}
                loadingMunicipality={loadingMunicipios}
                municipalityOptions={municipioOptions}
                isModalConfirmUnblockVisible={isModalConfirmUnblockVisible}
                setModalConfirmUnblockVisible={setModalConfirmUnblockVisible}
                isModalConfirmAgencyEntityBlockVisible={isModalConfirmAgencyEntityBlockVisible}
                setModalConfirmAgencyEntityBlockVisible={setModalConfirmAgencyEntityBlockVisible}
                loadModalconfirmUnblock={loadModalconfirmUnblock}
                loadModalconfirmAgencyEntityBlock={loadModalconfirmAgencyEntityBlock}
                setSelectedAgency={setSelectedAgency}
                selectedAgency={selectedAgency}
                successMsg={successMsg}
                setSuccessMsg={setSuccessMsg}
                searchResult={orgaoEntidadeList}
                setSearchResult={setOrgaoEntidadeList}
                history={props.history}
                totalFilter={totalFilter}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                erroMsg={erroMsg}
                setErroMsg={setErroMsg}
                rangePages={rangePages}
                setRangePages={setRangePages}
                modalError={modalError}
                setModalError={setModalError}
                cleanFilter={cleanFiltro}
                setCleanFilter={setCleanFiltro}
                newStatus={newStatus}
            />
        </>
    );
}